import {HStack, Icon, Text, ThemeColorPath, ThemeIconKey} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

interface RequirementChecklistItemProps extends TestIdProps {
  title: string;
  isMet: boolean;
}

const MET_ICON: ThemeIconKey = 'action/check_circle';
const UNMET_ICON: ThemeIconKey = 'navigation/cancel';
const MET_COLOR: ThemeColorPath = 'severity.success';
const UNMET_COLOR: ThemeColorPath = 'severity.danger';

export function RequirementChecklistItem(props: RequirementChecklistItemProps) {
  return (
    <HStack spacing={2} align="flex-start" data-testid={suffixTestId('checklistItem', props)}>
      <Icon
        value={props.isMet ? MET_ICON : UNMET_ICON}
        size={4}
        color={props.isMet ? MET_COLOR : UNMET_COLOR}
      />
      <Text size="small" color={props.isMet ? 'primary' : 'danger'}>
        {props.title}
      </Text>
    </HStack>
  );
}
